import React, { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { makeStyles, Box, Button, TextField } from "@material-ui/core";

import LinearProgress from "@material-ui/core/LinearProgress";
import { customer_send_kyc_otp } from "../../../redux/oms/customer_insert_send_kyc_otp";
import {
  handleNotificationAlertTryUpdate,
  handleNotificationAlertCatch,
} from "../../../components/method/handleNotificationAlert";
import { Formik } from "formik";
import * as Yup from "yup";
import { Clear } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    minHeight: 315,
    minWidth: 450,
    margin: "auto",
    position: "relative",
    backgroundColor: "white",
    padding: 15,
    borderRadius: 8,
    [theme.breakpoints.down("700")]: {
      minWidth: "100% !important",
    },
  },

  btnOtline: {
    fontSize: 14,
    backgroundColor: "transparent",
    color: "#ffffff",
    margin: "0 5px",
    padding: "9px 20px",
    border: `1px solid #ffffff`,
    [theme.breakpoints.down("1236")]: {
      padding: "9px 7px",
    },
    "&:hover": {
      backgroundColor: "#ffffff",
      color: "#071b2c",
    },
  },
  btnOtlineBlack: {
    fontSize: 14,
    backgroundColor: "white",
    color: "black",
    margin: "0 5px",
    padding: "9px 20px",
    border: `1px solid black`,
    [theme.breakpoints.down("1236")]: {
      padding: "9px 7px",
    },
    "&:hover": {
      backgroundColor: "black",
      color: "white",
    },
    [theme.breakpoints.down("500")]: {
      minWidth: "100% !important",
      marginBottom: "10px",
    },
  },
  openAccountRed: {
    backgroundColor: theme.palette.light.type2,
    color: "white",
    margin: "0 5px",
    padding: "9px 20px",
    border: `1px solid ${theme.palette.light.type2}`,
    fontSize: 14,
    [theme.breakpoints.down("1236")]: {
      padding: "9px 7px",
    },
    "&:hover": {
      backgroundColor: "#ffffff",
      color: theme.palette.light.type2,
      border: `1px solid ${theme.palette.light.type2}`,
    },
    [theme.breakpoints.down("500")]: {
      minWidth: "100% !important",
      width: "100%",
    },
  },
  gridBtns: {
    direction: "rtl",
    [theme.breakpoints.down("500")]: {
      minWidth: "100% !important",
      display: "flex",
      flexDirection: "column-reverse",
      flexWrap: "wrap",
    },
  },
  loading: {
    width: "99%",
    margin: "auto",
    top: "4px",
    zIndex: 2,
  },
  TextField: {
    minWidth: "250px",
    [theme.breakpoints.down("1400")]: {
      minWidth: "100% !important",
    },
  },
}));

export default function Index({
  setIndexChild,
  setOpen,
  state,
  setState,
  textError,
}) {
  let classes = useStyles();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const formRef = useRef();
  // const { submitForm } = useFormikContext();

  let initialValues = {
    national_id: "",
  };

  const validateShcama = Yup.object().shape({
    national_id: Yup.string().required(textError),
  });

  let onSubmit = (values, { setSubmitting }) => {
    let _data = {
      national_id: values?.national_id,
    };

    setLoading(true);
    customer_send_kyc_otp(_data)
      .then((res) => {
        setLoading(false);
        handleNotificationAlertTryUpdate(res);

        if (res.data.response.data.state === "OTP SENT") setIndexChild(1);
        setState({ national_id: values?.national_id });
      })
      .catch(() => {
        setLoading(false);
        handleNotificationAlertCatch(dispatch);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      {loading && <LinearProgress className={classes["loading"]} />}
      <div className={classes["root"]}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h3>تغییر پنل معاملاتی</h3>
          <Clear
            style={{ fill: "red", cursor: "pointer" }}
            onClick={() => setOpen(false)}
          />
        </div>
        <hr />

        <div>
          <p className={"text-justify h6"}>
            سرمایه‌گذار محترم در این بخش می‌توانید پنل معاملاتی خود را از رایان
            به تدبیر یا بالعکس تغییر دهید.
          </p>
          <p className={"text-justify h6"}>
            جهت تغییر سامانه معاملاتی کد ملی خود را وارد کنید
          </p>
        </div>
        <div>
          <Formik
            innerRef={formRef}
            initialValues={{ ...initialValues }}
            validationSchema={validateShcama}
            onSubmit={onSubmit}
          >
            {({ values, touched, errors, handleSubmit, setFieldValue }) => (
              <>
                <div className={""}>
                  {/* <div>
                                            <p>
                                                کد تایید دریافت شده از سامانه سجام:
                                            </p>
                                        </div> */}
                  <div style={{ width: "100%" }}>
                    <form onSubmit={handleSubmit} style={{ width: "100%" }}>
                      <Box
                        width="100%"
                        style={{
                          width: "100%",
                          paddingTop: 13,
                          paddingBottom: 15,
                        }}
                      >
                        <TextField
                          id="outlined-name"
                          // label="کد ملی"
                          value={values.national_id}
                          onChange={(event) =>
                            setFieldValue("national_id", event.target.value)
                          }
                          margin="normal"
                          variant="outlined"
                          style={{ width: "50%" }}
                          className={classes["TextField"]}
                          placeholder="لطفا کد ملی خود را وارد کنید"
                        />
                        {touched.national_id && errors.national_id && (
                          <div className={"textError"}>
                            {/* {textError} */}
                            لطفا کد ملی خود را وارد کنید
                          </div>
                        )}
                      </Box>
                    </form>
                  </div>
                </div>
                <div className={classes["gridBtns"]}>
                  <Button
                    className={classes.btnOtlineBlack}
                    onClick={() => setOpen(false)}
                  >
                    لغو
                  </Button>
                  <Button
                    className={classes.openAccountRed}
                    onClick={() => handleSubmit()}
                  >
                    ارسال کد تایید
                  </Button>
                </div>
              </>
            )}
          </Formik>
        </div>

        {/* <Box style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 20 }} >
                    <button
                        className={'btnsBlue'}
                        onClick={() => handelSubmit(state.national_id)}
                    >
                        ارسال کد تایید
                    </button>
                  
                </Box> */}
      </div>
    </>
  );
}
